import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the top of the page on every route (pathname) change.
// useLayoutEffect runs before paint, so there's no visible scroll flash.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
